import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';

import { Label, FormWrapper, FormField } from 'libs/forms/styles';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { PasswordField } from 'libs/forms/views/fieldTypes/password';
import FormActionButton from 'libs/forms/views/formActionButton';

import Heading from 'components/Heading';
import Logo from 'components/Logo';
import Button from 'components/Button';

import {
  WrapperSignInForm,
  MainSignInFormColumn,
  Footer,
  FooterLabel,
} from 'apps/signIn/styles';
import { Spacer } from 'styles/utils';
import { SocialButtons } from 'apps/signIn/views/socialButtons';

@withNamespaces()
@observer
export class SignInForm extends React.Component {
  render() {
    const {
      form,
      title,
      handleRequestInvite,
      handleSignIn,
      handleNoAccount,
      handleForgotPassword,
    } = this.props;
    return (
      <WrapperSignInForm>
        <MainSignInFormColumn>
          <Link name='home'>
            <Logo size='48px' />
          </Link>
          <Spacer size='xxlarge' />

          <Heading level={1} size='large'>
            <Trans>{title}</Trans>
          </Heading>
          <SocialButtons />

          <FormWrapper
            posting={form.posting}
            onSubmit={e => {
              e.preventDefault();
              form.prepare();
              handleSignIn();
            }}
            responsive
            maxResponsive
          >
            <FormField>
              <Label>
                <Trans>Username or email</Trans>
              </Label>
              <TextField
                fieldStore={form.fieldStores.get('usernameEmail')}
                responsive
              />
            </FormField>
            <FormField>
              <Label>
                <Trans>Password</Trans>
              </Label>
              <PasswordField
                fieldStore={form.fieldStores.get('password')}
                responsive
              />
            </FormField>

            <Button
              onClick={handleForgotPassword}
              appearance='plain'
              variant='secondary'
              size='xsmall'
              text={<Trans>Forgot your password?</Trans>}
            />

            <Spacer size='large' />

            <FormActionButton
              formStore={form}
              data-test-id='sign-in-button'
              buttonText='Sign in'
              buttonTextPosting={form.conf.buttonTextPosting}
              variant='primary'
            />
          </FormWrapper>
        </MainSignInFormColumn>
        <Footer>
          <FooterLabel>
            <Trans>Not a member yet?</Trans>
          </FooterLabel>
          <Button
            text={
              INVITE_MODE ? (
                <Trans>Request invite</Trans>
              ) : (
                <Trans>Sign up</Trans>
              )
            }
            icon='arrow_right'
            iconPosition='right'
            variant='tertiary'
            size='default'
            outline
            onClick={INVITE_MODE ? handleRequestInvite : handleNoAccount}
          />
        </Footer>
      </WrapperSignInForm>
    );
  }
}

SignInForm.propTypes = {
  form: PropTypes.object,
  title: PropTypes.string,
  handleSignIn: PropTypes.func,
  handleNoAccount: PropTypes.func,
  handleForgotPassword: PropTypes.func,
  handleRequestInvite: PropTypes.func,
};
